import 'css-chunksrc/client/scenes/notifications/loader/styles.scss';export default {
  "loader": "_loader_1rdtc_1",
  "row": "_row_1rdtc_8",
  "breadcrumbs": "_breadcrumbs_1rdtc_14",
  "breadcrumb": "_breadcrumb_1rdtc_14",
  "date": "_date_1rdtc_26",
  "main": "_main_1rdtc_30",
  "resource": "_resource_1rdtc_34"
};